<template>
  <v-app class="yc-application-user-guide overflow-hidden">
    <v-app-bar class="yc-app-bar" height="56" max-height="56" color="#FFFFFF">
      <img src="../../assets/images/M-Suite Logo.svg" style="cursor: pointer" @click="reloadWindows('/user-guide/index')"/>
      <span class="v-divider-app-bar mr-4 ml-4"></span>
      <p class="txt-subtitle justify-center align-center ma-0"
         style="min-width: 150px;width: 100%;max-width: 400px;">Agent Guide</p>
      <div class="yc-search">
        <v-text-field v-model="search"
                      :placeholder="$t('USER_GUIDE.SEARCH_PLACEHOLDER')"
                      height="40"
                      clearable
                      color="black"
                      @keydown.enter="goToRouter('/user-guide/search', search)"
                      class="yc-search-input mr-4 ml-8">
          <template v-slot:prepend-inner>
            <v-icon class="icon-search"></v-icon>
          </template>
        </v-text-field>
      </div>
      <v-spacer/>
      <div class="d-flex justify-center align-center mr-1" style="min-width: 100px;cursor: pointer"
           @click="goToRouter('/user-guide/contact')">
        <span
            class="yc-icon yc-icon--small mr-2 icon-contact"
        ></span>
        <span>{{ $t('USER_GUIDE.CONTACT_US') }}</span>
      </div>
    </v-app-bar>
    <v-divider/>
    <v-main class="yc-content" id="yc-content" style="max-width: 100% !important; margin: 0;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue"
import _ from 'lodash'
import msDataProvider from "@/services/msDataProvider";
import i18n from "@/lang";

export default Vue.extend({
  name: "Index",
  data() {
    return {
      search: "",
      loading: true
    }
  },
  methods: {
    goToRouter(path, query = {}) {
      if (!query) {
        return;
      }
      if (path === this.$route.path && !this.$route.query) {
        return
      }
      query = {
        search: query
      }
      if (query && _.isEmpty(query.search)) {
        this.$router.push({'path': path})
      } else {
        if (query === this.$route.query) {
          return;
        }
        this.$router.push({'path': path, 'query': query})
      }
    },
    reloadWindows(url) {
      if (url === this.$route.path) {
        location.hash = ''
        location.search = ''
      } else {
        this.$router.push({path: url})
      }
    },
    async getData() {
      const setting = await msDataProvider.getData("setting");
      if (setting) {
        i18n.locale = setting.language ? setting.language : 'vi'
      }
    }
  },
  async mounted() {
    await this.getData()
  },
  created() {
    const query = this.$route.query
    if (query && query.search) {
      this.search = query.search
    }
    if (query && query.serverName) {
      sessionStorage.setItem('serverName', query.serverName);
    }
  },

})
</script>

<style lang="scss">
.text-warning {
  //color: #ffcc00!important;
  font-weight: bold !important;
}
</style>
